import React from 'react'
import './ProfileAuthorProfileCard.css'
import FileCopyIcon from '@material-ui/icons/FileCopy'

function ProfileAuthorProfileCard() {
    return (
        <>
        <img src="https://images.rarible.com/?fit=outsize&n=-1&url=https%3A%2F%2Fipfs.rarible.com%2Fipfs%2FQmNnZp34kbP2uuELN8en1qSYtMeKDfEpcyYrHqE1aeRBK2&w=240" alt="" className="authorImg"/>
        <ul className="authorData">
            <li><h1 className="authorName">Jon Smith</h1></li>
            <li><span className="authorInfo">@username</span></li>
            <li><span className="authorInfo wallet">0x1af70e564847be46e <FileCopyIcon /></span></li>
        </ul>
        </>
    )
}

export default ProfileAuthorProfileCard
